import ApiService from '../apiservice'

export default class VinculoPrevidenciarioService extends ApiService {
  constructor() {
    super('/vinculo-previdenciario');
  }

  cadastrar(vinculo) {
    return this.post('/',vinculo);
  }

  consultarPorPessoa(pessoaId) {
    return this.get(`/por-pessoa/${pessoaId}`);
  }

  consultar(codigo) {
    return this.get(`/consulta-por-codigo/${codigo}`);
  }

  alterar(vinculo) {
    return this.put('/',vinculo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}